var custom = require('./custom');
var defaultContract = require('./default');
var rental = require('./rental');
var loan = require('./loan');

// Overlay script-type list (advanced editor). Default is the jade-key path,
// not an editor starter — keep Custom / Rental in the UI selector only.
// LOAN_SCRIPT is Vault-internal — never listed here.
var CONTRACTS = [custom, rental];
function listContracts() {
  return CONTRACTS.map(function (c) {
    return {
      id: c.id,
      label: c.label,
      description: c.description
    };
  });
}
function getContract(id) {
  if (id === defaultContract.id) {
    return defaultContract;
  }
  return CONTRACTS.find(function (c) {
    return c.id === id;
  }) || null;
}
function getContractScriptJson(id) {
  var pretty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var build_opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var contract = getContract(id);
  if (!contract) {
    return '';
  }
  var script = typeof contract.build === 'function' ? contract.build(build_opts) : contract.script;
  if (!script) {
    return '';
  }
  return pretty ? JSON.stringify(script, null, 2) : JSON.stringify(script);
}
function getDefaultContractId() {
  return custom.id;
}

/**
 * Canonical default Vault access script (CHECKOWNNFT).
 * Used by jade-key mint and standard download request paths.
 */
function buildDefaultAccessScript() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return defaultContract.build(opts);
}

/**
 * FILE_TX rental access script: IS_CREATOR OR (CHECKPATHHOP AND DB_UPDATE_LOGIC).
 */
function buildRentalAccessScript() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return rental.build(opts);
}

/**
 * DB_UPDATE_LOGIC subtree from the Rental Master Key (not a separate contract).
 */
function buildDbUpdateSchema() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return rental.build(opts).args[1].args[1];
}

/**
 * Vault-defined LOAN_SCRIPT template (not an editor contract).
 */
function buildLoanScript() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return loan.build(opts);
}
function instantiateLoanScript() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return loan.instantiate(opts);
}
module.exports = {
  listContracts: listContracts,
  getContract: getContract,
  getContractScriptJson: getContractScriptJson,
  getDefaultContractId: getDefaultContractId,
  buildDefaultAccessScript: buildDefaultAccessScript,
  buildRentalAccessScript: buildRentalAccessScript,
  buildDbUpdateSchema: buildDbUpdateSchema,
  buildLoanScript: buildLoanScript,
  instantiateLoanScript: instantiateLoanScript
};